import axios from "axios";
import React, {useEffect, useState} from "react";
import {useLocation} from "react-router";
import {GRAPHQL, LECTURE_PAYMENT, PAYMENT_CANCEL} from "../../../constants/ApiUrl";
import {GET_LECTURE_LISTENER_QUERY} from "../../../constants/query/Lecture.query";
import {InitialListProps, ListColumnType, ListProps} from "../../common/list/List.props";
import Pagination from "../../common/pagination/Pagination";
import {ListenerStatusType} from "../constant/Status.type";
import {ListenerDto} from "../dto/Lecture.dto";
import * as LISTENER_LIST_PROPS from "./constants/ListenerList.props";
import Search from "./search/Search";
import "./style.css";
import {InitialPaginationProps, PaginationProps} from "../../common/pagination/Pagination.props";
import Empty from "../../common/empty/Empty";

export default function Listener() {
    const location = useLocation();

    const [statusTypes, setStatusTypes] = useState<ListenerStatusType[]>([]);
    const [keyword, setKeyword] = useState<string>("");
    const [checkedSeqs, setCheckedSeqs] = useState<number[]>([]);
    const [paginationProps, setPaginationProps] = useState<PaginationProps>(InitialPaginationProps);
    const [listProps, setListProps] = useState<ListProps<ListenerDto>>(InitialListProps);

    useEffect(() => {
        setListProps({
            headers: [...LISTENER_LIST_PROPS.HEADERS, {
                type: ListColumnType.BUTTON,
                name: "",
                key: "",
                button: {
                    name: "결제 취소",
                    onClick: () => {
                    }
                }
            }],
            items: [],
            emptyProps: LISTENER_LIST_PROPS.EMPTY_PROPS(),
            onCheckedChange: (seqs: number[]) => setCheckedSeqs(seqs)
        });

        setPaginationProps(prevState => ({
            ...prevState,
            onChange: changePage
        }));
    }, []);

    const changePage = (page: number) => {
        setPaginationProps(prevState => ({
            ...prevState,
            currentPage: page
        }));
    }

    useEffect(() => {
        getListeners();
    }, [statusTypes, keyword, paginationProps.currentPage]);

    const getListeners = () => {
        axios.post(GRAPHQL, {
            query: GET_LECTURE_LISTENER_QUERY(location.state.seq, keyword, statusTypes, paginationProps.currentPage)
        }).then(response => {
            const listenerResponse = response.data.data.getListeners;

            setPaginationProps(prevState => ({
                ...prevState,
                totalPage: listenerResponse.totalPage,
                currentPage: listenerResponse.currentPage
            }));
            setListProps(prevState => ({
                ...prevState,
                items: listenerResponse.items
            }));
        });
    }

    const handleCheckboxClick = (seq: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked;
        if (checked) {
            setCheckedSeqs([...checkedSeqs, seq]);
        } else {
            setCheckedSeqs(checkedSeqs.filter(checkedSeq => checkedSeq !== seq));
        }
    }

    const cancelPayment = (listener: ListenerDto) => {
        axios.get(LECTURE_PAYMENT(listener.seq)).then(response => {
            if (response.data.seq > 0) {
                axios.put(PAYMENT_CANCEL(response.data.seq)).then(response => {
                    alert("결제 취소가 완료되었습니다.");
                    getListeners();
                });
            } else {
                alert("결제 취소에 실패하였습니다.");
            }
        });
    }

    const cancelSelectedPayment = () => {
        if (checkedSeqs.length === 0) {
            alert("선택된 신청자가 없습니다.");
            return;
        }

        let successCount = 0;

        for (const seq of checkedSeqs) {
            axios.get(LECTURE_PAYMENT(seq)).then(response => {
                if (response.data.seq > 0) {
                    axios.put(PAYMENT_CANCEL(response.data.seq)).then(response => {
                        getListeners();
                        successCount++;

                        if (successCount === checkedSeqs.length) {
                            alert("선택된 신청자의 결제 취소가 완료되었습니다.");
                        }
                    });
                }
            });
        }
    }

    return (
        <div className="lecture-management">
            <main className="wrapper">
                <div className="lecture-body">
                    <Search setListenerStatusType={setStatusTypes} setKeyword={setKeyword} setPage={changePage}/>
                    <div className="lecture-numbers">
                        <div className="lecture-wrapper">
                            <div className="lecture-all-number" data-testid="total-count">
                                신청자 {location.state.count}명
                            </div>
                            <div className="lecture-choice">
                                <button onClick={() => cancelSelectedPayment()} className="delete sole">
                                    선택항목 일괄취소
                                </button>
                            </div>
                        </div>
                        <div className="common-list-wrap">
                            {listProps.items.length === 0 && <Empty {...listProps.emptyProps}/>}
                            {listProps.items.length > 0 && (
                                <table>
                                    <thead>
                                    <tr>
                                        {listProps.headers.map((header, index) => (
                                            <th key={index}>
                                                {header.name}
                                            </th>
                                        ))}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {listProps.items.map((item, index) => (
                                        <tr key={index}>
                                            {listProps.headers.map((header, index) => {
                                                if (header.type === ListColumnType.CHECK_BOX) {
                                                    if (item.status === ListenerStatusType.PAID) {
                                                        return (
                                                            <td key={index}>
                                                                <input type="checkbox"
                                                                       onChange={(event) => handleCheckboxClick(item.seq, event)}/>
                                                            </td>
                                                        )
                                                    } else {
                                                        return (
                                                            <td key={index} className="empty-check-box"></td>
                                                        )
                                                    }
                                                } else {
                                                    return (
                                                        <td key={index}
                                                            style={header.getCellStyle ? header.getCellStyle(item[header.key as keyof ListenerDto]) : {}}>
                                                            {header.convertToString ? header.convertToString(item[header.key as keyof ListenerDto]) : item[header.key as keyof ListenerDto]}
                                                        </td>
                                                    )
                                                }
                                            })}
                                            {
                                                item.status === ListenerStatusType.PAID ? (
                                                    <td>
                                                        <button className="delete" onClick={() => cancelPayment(item)}>
                                                            결제 취소
                                                        </button>
                                                    </td>
                                                ) : (
                                                    <td className="empty-box"></td>
                                                )
                                            }
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                    <Pagination {...paginationProps}/>
                </div>
            </main>
        </div>
    )
}